import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";
import { tenantGroup } from "utils/optionData/utils";
import AddEditTenentGroup from "./AddEditTenentGroup";

const TenantGroupDropdown = ({
  onChange = () => {},
  defaultValue,
  name,
  newItemLabel,
  disabledDropdown,
}) => {
  const [options, setOptions] = useState([]);
  const [openModalView, setOpenModalView] = useState(false);

  const getAllOptions = async () => {
    try {
      const result = await apiGet("/v1/tenentgroup", false);
      const response = result.data.map((data) => ({
        id: data.id,
        label: data.tenentGroupName,
      }));
      setOptions(response);
    } catch (err) {
      console.log(err);
    }
  };

  const onAddNew = () => {
    setOpenModalView(true);
  };

  useEffect(() => {
    getAllOptions();
  }, []);

  const handleDropdownChange = (value) => {
    const selectedOption = options.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  return (
    <>
      {openModalView && (
        <AddEditTenentGroup
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          onSuccess={getAllOptions}
        />
      )}
      <DropdownWithSearch
        defaultValue={defaultValue}
        placeholder="Select Group"
        options={options}
        onChange={handleDropdownChange}
        borderColor="#ED850C"
        disabled={false}
        onAddNew={onAddNew}
        newItemLabel={newItemLabel}
        width="358px"
        disabledDropdown={disabledDropdown}
      />
    </>
  );
};

export default TenantGroupDropdown;
